import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { authApi, espnApi } from '../utils/api';

const UserLeaguesContext = createContext({ leagues: null, refetch: () => {} });

export function UserLeaguesProvider({ children }) {
  const [leagues, setLeagues] = useState(null); // null = loading, [] = loaded empty
  const { isSignedIn, isLoaded, getToken } = useAuth();

  const fetchLeagues = useCallback(async () => {
    const token = await getToken();
    if (!token) return;

    const yahooLeagues = await authApi.getLeagues(token)
      .then(data => (data.leagues || []).map(l => ({ ...l, provider: 'YAHOO', sport: 'NHL' })))
      .catch(() => []);

    const espnLeagues = await espnApi.getLeagues(token)
      .then(data => data.leagues || [])
      .catch(() => []);

    setLeagues([...yahooLeagues, ...espnLeagues]);
  }, [getToken]);

  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) { setLeagues([]); return; }
    fetchLeagues();
  }, [isLoaded, isSignedIn, fetchLeagues]);

  return (
    <UserLeaguesContext.Provider value={{ leagues, refetch: fetchLeagues }}>
      {children}
    </UserLeaguesContext.Provider>
  );
}

export function useUserLeagues() {
  return useContext(UserLeaguesContext);
}
